import { getPublicRuntimeConfig } from '../../libs/init/getPublicRuntimeConfig';
import { normalizePatientRoomSlug } from './normalizePatientRoomSlug';

const stripBasename = (pathname: string): string => {
  const basename = getPublicRuntimeConfig().paths.base;
  if (basename !== '' && pathname.startsWith(basename)) {
    return pathname.slice(basename.length) || '/';
  }
  return pathname;
};

/**
 * Parses the patient room slug from a check-in URL pathname.
 * Works with full browser paths (`/v2/check-in/al`) and RR paths (`/check-in/al`).
 */
export const getPatientRoomSlugFromPathname = (pathname: string): string => {
  const withoutQuery = pathname.split('?')[0] ?? pathname;
  const normalizedPath = stripBasename(withoutQuery).replace(/\/+$/u, '');
  const segments = normalizedPath.split('/');
  const checkInIndex = segments.indexOf('check-in');

  if (checkInIndex === -1) {
    return '';
  }

  return normalizePatientRoomSlug(segments.slice(checkInIndex + 1).join('/'));
};
